import { cn } from '@/utils/cn'
import type { CsHealthBand } from '@/services/csService'

const BAND_CONFIG: Record<CsHealthBand, { label: string; className: string }> = {
  verde: { label: 'Saudável', className: 'bg-emerald-500/15 text-emerald-400 border-emerald-500/25' },
  amarelo: { label: 'Atenção', className: 'bg-amber-500/15 text-amber-400 border-amber-500/25' },
  vermelho: { label: 'Risco', className: 'bg-rose-500/15 text-rose-400 border-rose-500/25' },
}

export function CsHealthBadge({
  score,
  band,
  compact,
  max = 18,
}: {
  score: number
  band: CsHealthBand
  compact?: boolean
  /** Escala exibida (final 0–18 por padrão). */
  max?: number
}) {
  const cfg = BAND_CONFIG[band]
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-xs font-semibold',
        cfg.className,
        compact && 'text-[10px]',
      )}
    >
      {cfg.label}
      {!compact && (
        <span className='opacity-70'>
          · {score}/{max}
        </span>
      )}
    </span>
  )
}
